/**
 * AttachmentModal Component
 * Full-screen modal for viewing attachments (PDF, images, videos)
 */
import AttachmentModalHeader from './AttachmentModalHeader'
import AttachmentModalContent from './AttachmentModalContent'
import AttachmentModalFooter from './AttachmentModalFooter'
import '../styles/AttachmentModal.css'

export default function AttachmentModal({ show, attachment, onClose }) {
  if (!show || !attachment) return null

  return (
    <div className="attachment-modal-overlay" onClick={onClose}>
      <div className="attachment-modal-container" onClick={(e) => e.stopPropagation()}>
        <AttachmentModalHeader
          title={attachment.name || 'Attachment Viewer'}
          onClose={onClose}
        />
        <AttachmentModalContent attachment={attachment} />
        <AttachmentModalFooter attachment={attachment} />
      </div>
    </div>
  )
}
